/**
* ─────────────────────────────────────────────────────────────────────
* FILE: src/pages/Waitlist.tsx
* DESCRIPTION: Waitlist registration page for Beta access control.
* @copyright 2025-2026 Anou. All rights reserved.
* ─────────────────────────────────────────────────────────────────────
*/
import { Waitlist } from '@clerk/react'
import { Link } from 'react-router-dom'
import { ShieldCheck, ArrowRight } from 'lucide-react'

export default function WaitlistPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        {/* Header */}
        <div className="text-center">
          <div className="mx-auto h-16 w-16 bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl flex items-center justify-center shadow-lg mb-6">
            <ShieldCheck className="h-8 w-8 text-white" />
          </div>
          <h2 className="mt-6 text-3xl font-bold text-gray-900 dark:text-white">
            Join our Beta version
          </h2>
          <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
            We're currently accepting a limited number of users for our closed Beta.
            Enter your email below to request access.
          </p>
        </div>

        {/* Waitlist Card */}
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-700 p-8">
          <Waitlist
            appearance={{
              elements: {
                rootBox: "w-full",
                card: "shadow-none border-none p-0",
                headerTitle: "hidden",
                headerSubtitle: "hidden",
                formButtonPrimary: "bg-blue-600 hover:bg-blue-700 text-sm normal-case py-3 w-full",
                footerActionLink: "text-blue-600 hover:text-blue-500",
              }
            }}
          />
          {/* Custom Footer / Login Link */}
          <div className="mt-6 pt-6 border-t border-gray-200 dark:border-gray-700 text-center">
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Already have access?{' '}
              <Link to="/sign-in" className="font-medium text-blue-600 hover:text-blue-500 flex items-center justify-center gap-1 mt-2">
                Sign in to your account
                <ArrowRight className="w-4 h-4" />
              </Link>
            </p>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex items-center justify-center gap-4 text-xs text-gray-500 dark:text-gray-400">
          <span className="flex items-center gap-1">
            <ShieldCheck className="w-3 h-3" /> Secure
          </span>
          <span>•</span>
          <span>No spam</span>
          <span>•</span>
          <span>Beta Access Only</span>
        </div>
      </div>
    </div>
  )
}
